import './CaseShop.css'
import { CaseData } from '../../../models/Case';
import { CaseShopCard } from './CaseShopCard/CaseShopCard';

interface CaseShopProps {
    cases?: CaseData[];
}

export const CaseShop = ({ cases }: CaseShopProps) => {
    return (
    
        <div className="shop-container"
        >    
            <div className="case-shop-cards-container"
            style={{width: '100%', height: '100%'}}>
                {cases?.map((item) => (
                    <CaseShopCard 
                        key={item.id} 
                        name={item.name} 
                        price={item.price} 
                        onBuy={item.onBuy}
                        onCardClick={item.onCardClick}
                    />
                ))}
            </div>
        </div>
    )
}